import { render } from "./CreateResetPassword.vue?vue&type=template&id=3a1d9191&scoped=true"
import script from "./CreateResetPassword.vue?vue&type=script&lang=js"
export * from "./CreateResetPassword.vue?vue&type=script&lang=js"

import "./CreateResetPassword.vue?vue&type=style&index=0&id=3a1d9191&lang=scss&scoped=true"

import exportComponent from "/var/www/production/releases/51/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1d9191"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBtn,QIcon,QForm,QInput});
